// @flow

import ThreeDSecureMode from '@tectonics/prs/threedsecure/threedsecure-mode';
import CheckoutThreedsModeDecisionRuleInvalidException from '@tectonics/prs/threedsecure/threedsecure-mode-decision-rule-invalid-exception';

export default class ThreeDSecureModeDecisionRule
{
  mode: ThreeDSecureMode;
  paymentType: string|null;
  brand: string|null;
  minAmountUsd: number|null;

  constructor(mode: ThreeDSecureMode, paymentType: string|null, brand: string|null, minAmountUsd: number|null) {
    this.mode = mode;
    this.paymentType = paymentType;
    this.brand = brand;
    this.minAmountUsd = minAmountUsd;
  }

  static tryFromData(data: Object): ThreeDSecureModeDecisionRule|null {
    try {
      return new ThreeDSecureModeDecisionRule(
        this.retrieveValidModeFromDataOrCry(data),
        this.retrieveValidPaymentTypeFromDataOrNull(data),
        this.retrieveValidBrandFromDataOrNull(data),
        this.retrieveValidMinAmountFromDataOrNull(data),
      );
    } catch (e) {
      return null;
    }
  }

  static retrieveValidModeFromDataOrCry(data: Object): ThreeDSecureMode {
    const mode = Object.values(ThreeDSecureMode).find(value => value === data.mode.toLowerCase());
    if (mode === undefined) {
      throw new CheckoutThreedsModeDecisionRuleInvalidException('Invalid mode');
    }

    return mode;
  }

  static retrieveValidPaymentTypeFromDataOrNull(data: Object): string|null {
    if (data.rule && data.rule.payment_type) {
      return data.rule.payment_type;
    }

    return null;
  }

  static retrieveValidBrandFromDataOrNull(data: Object): string|null {
    if (data.rule && data.rule.brand) {
      return data.rule.brand;
    }

    return null;
  }

  static retrieveValidMinAmountFromDataOrNull(data: Object): number|null {
    return data?.rule?.min_amount_usd;
  }

  isSatisfied(paymentType: string|null, brand: string|null, amount: number|null): boolean {
    if (this.paymentType !== null
        && paymentType !== null
        && this.paymentType.toLowerCase() !== paymentType.toLowerCase()
    ) {
      return false;
    }

    if (this.brand !== null
        && brand !== null
        && this.brand.toLowerCase() !== brand.toLowerCase()
    ) {
      return false;
    }

    return minAmountMatches(this.minAmountUsd, amount);
  }
}

function minAmountMatches(minAmount: number|null, amount: number|null): boolean {
  if(!minAmount) {
    return true;
  }

  if(!amount) {
    return false;
  }

  return amount >= minAmount;
}
